
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { QueryModel } from 'models/generated/Entities.GormCrm.Query';


const _gormCrm_QueryControllerHelper = new Map<string, Object>();
_gormCrm_QueryControllerHelper.set('GetQuery', QueryModel);
_gormCrm_QueryControllerHelper.set('GetQueries', QueryModel);
_gormCrm_QueryControllerHelper.set('SaveQuery', QueryModel);


export const gormCrm_QueryControllerHelper = _gormCrm_QueryControllerHelper;

